"use client"
import { Modal } from "@/components/ui/Modal"
import Link from "next/link"
import { Button } from "@/components/ui/Button"
import { useState } from "react"
import { acceptTerms } from "./action"

export function TermsPopup({ acceptedTermsCookie }: { acceptedTermsCookie: string | undefined }) {
  const [isOpen, setIsOpen] = useState(!acceptedTermsCookie)

  const handleAcceptTerms = async () => {
    await acceptTerms()
    setIsOpen(false)
  }
  return (
    <Modal isOpen={isOpen} isCentered title="Terms of Service" size="md" onClose={handleAcceptTerms}>
      <div className="space-y-4 pb-2">
        <p>
          By using TrendWatching, you agree to our{" "}
          <Link
            prefetch={false}
            href="/trendwatching-platform-terms.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-700"
          >
            terms & conditions
          </Link>{" "}
          and{" "}
          <Link
            href="https://www.trendwatching.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-700"
          >
            privacy & cookie policy
          </Link>
          .
        </p>

        <Button className="w-full" onClick={handleAcceptTerms}>
          Continue
        </Button>
      </div>
    </Modal>
  )
}
